<template lang="html">
  <div class="col-cart-data loggedin-cart">

    <div class="card card-1">
        <div class="card-body">
            <div class="row justify-content-between mb-3">
                <div class="col-auto">
                    <h3 style="color: #00be5e;"><b>EUM000{{ order.id }}</b></h3>
                </div>
                <div class="col-auto "> <small><b>Estatus</b> : {{ order.status }}</small> </div>
            </div>
            <div class="row invoice">
                <div class="col">
                    
                    <p class="mb-1"><b>Fecha del pedido :</b> {{ order.date }}</p>
                    <p><b>Número de pedido:</b> EUM000{{ id}}</p>

                    <div v-if="order.status == 'No Pagado'">
                        <p class="mb-1"><b>Forma de pago :</b>  <v-select v-model="order.paymentMethod" :options="[{id:'Deposito ALBO'},{id:'Deposito BBVA'},{id:'Mercadopago'}]" label="id" index="id"/>
                        </p>
                        <div v-if="order.paymentMethod == 'Deposito ALBO'"><p class="mb-1"><b>Forma de pago :</b> Deposito - transferencia ALBO</p>
                            <p><img src="public/images/pages/cart/logo_albo.svg" width="80px"></p>
                        
                            <p><b>Banco:</b> {{depositinfo.banco_albo}}</p>
                            <p><b>Titular:</b> {{depositinfo.titular_albo}}</p>
                            <p><b>CLABE:</b> {{depositinfo.clabe_albo}}</p>
                            <p><b>Numero de cuenta:</b> {{depositinfo.numero_cuenta_albo}}</p>
                        </div>
                        <div v-else-if="order.paymentMethod == 'Deposito BBVA'">
                            
                            <p><img src="public/images/pages/cart/logo_bbva.svg" width="80px"></p>
                    
                            <p><b>Banco:</b> {{depositinfo.banco}}</p>
                            <p><b>Titular:</b> {{depositinfo.titular}}</p>
                            <p><b>CLABE:</b> {{depositinfo.clabe}}</p>
                            <p><b>Numero de cuenta:</b> {{depositinfo.numero_cuenta}}</p>
                        </div>
                        <div v-else-if="order.paymentMethod == 'Mercadopago'">

                            <div id="brick-checkout"></div>

                        </div>
                    </div>
                   <div v-else>
                        <p class="mb-1"><b>Forma de pago :</b> {{ order.paymentMethod }}</p>
                   </div>
                    
                    
                </div>
            </div>

            <hr>
            <div >
                <p class="mb-1 text-dark"><b>Direccion de entrega</b></p>
            </div>
            <div class="row">
                <b-form class="white-box" @submit.prevent="updateOrder">
                    <div class="col">
                        <div class="row mx-0 no-gutters">
                            <div class="col-md-12 col-lg-12">
                                <b-form-group class="custom-input" label="Calle:" label-for="i-calle">
                                    <b-form-input id="i-calle" type="text" v-model="order.street" size="sm" placeholder="Calle donde vive" required/>
                                </b-form-group>
                            </div>
                            <div class="col-md-6 col-lg-6">
                                <b-form-group class="custom-input" label="Numero exterior:" label-for="i-num">
                                    <b-form-input id="i-num" type="text" v-model="order.num_ext" size="sm" required/>
                                </b-form-group>
                            </div>
                            <div class="col-md-6 col-lg-6">
                                <b-form-group class="custom-input" label="Numero interior:" label-for="i-num">
                                    <b-form-input id="i-num" type="text" v-model="order.num_int" size="sm"/>
                                </b-form-group>
                            </div>
                        </div>
                        <div class="row mx-0 no-gutters">
                            <div class="col-md-12 col-lg-12">
                                <b-form-group class="custom-input" label="Colonia:" label-for="i-neighborhood">
                                    <b-form-input id="i-neighborhood" type="text" v-model="order.neighborhood" size="sm" placeholder="Colonia" required/>
                                </b-form-group>
                            </div>
                            <div class="col-md-12 col-lg-12">
                                <b-form-group class="custom-input" label="Codigo postal:" label-for="i-zipcode">
                                    <b-form-input id="i-zipcode" type="text" v-model="order.zipcode" size="sm" placeholder="Codigo postal" required/>
                                </b-form-group>
                            </div>
                        </div>
                        <div class="row mx-0 no-gutters">
                            <div class="col-md-6 pr-md-3">
                            <b-form-group class="custom-input" label="Estado:" label-for="i-estado">
                                <v-select v-model="order.state_id" :options="states" label="name" index="id" @change="getTowns"/>
                            </b-form-group>
                            </div>

                            <div class="col-md-6">
                            <b-form-group class="custom-input" label="Ciudad:" label-for="i-ciudad">
                                <v-select v-model="order.town_id" :options="towns" label="name" index="id"/>
                            </b-form-group>
                            </div>
                        </div>
                        <!-- <p class="mb-1">{{ order.street}}, {{ order.num_ext }}, {{  order.num_int ? order.num_int : null}}<br>
                        {{ order.neighborhood }}<br>
                        {{ order.zipcode }}<br>
                        {{ order.state }}<br>
                        {{ order.town }}</p> -->
                          
                        <b-button type="submit" class="btn-red btn-form" variant="primary">Cambiar direccion</b-button>

                    </div>
                </b-form>

                <div class="col">
                    <div class="row mx-0 no-gutters">

                        <div class="col-md-6 col-lg-6">
                            <b> Forma de envio:</b> {{ order.shipping_method }}<br>
                            <b> Guia:</b> {{ order.shipping_guide }}<br>
                            
                        </div>
                        <div class="col-md-6 col-lg-6">
                                <b-form-group class="custom-input" label="Numero interior:" label-for="i-num">
                                    <b-form-input id="i-num" type="text" v-model="order.num_int" size="sm"/>
                                </b-form-group>
                        </div>
                     </div>
                </div>
            </div>
            <div v-if="order.invoice == 1">
                <hr>
                <div >
                    <p class="mb-1 text-dark"><b>Datos de facturacion</b></p>
                </div>
                <div class="row">
                    <div class="col">
                        <p class="mb-1">{{ order.business_name_invoice }}</p>
                        <p class="mb-1">{{ order.rfc }}</p>
                        <p class="mb-1">{{ order.street_invoice}}, {{ order.num_ext_invoice }}, {{  order.num_int_invoice ? order.num_int_invoice : null}}<br>
                        {{ order.neighborhood_invoice }}<br>
                        {{ order.zipcode_invoice }}<br>
                        {{ order.state_invoice }}<br>
                        {{ order.town_invoice }}</p>
                    </div>
                </div>
            </div>
            


            <hr>
            <div >
                <p class="mb-1 text-dark"><b>Detalles del pedido</b></p>
            </div>
            <div class="row" v-for="(detail, index) in orderDetail" :key="index" >
                <div class="col">
                    <div class="card card-2">
                        <div class="card-body">
                            <div class="media">
                                <div class="sq align-self-center ">
                                    <img class="img-fluid my-auto align-self-center mr-2 mr-md-4 pl-0 p-0 m-0" :src="detail.imageUrl" width="50" height="50" />
                                </div>
                                <div class="media-body my-auto text-right">
                                    <div class="row my-auto flex-column flex-md-row">
                                        <div class="col-auto my-auto ">
                                            <h6 class="mb-0" v-html="detail.product"></h6>
                                        </div>
                                        <div class="col my-auto "> <small>SKU: {{ detail.sku }} </small></div>
                                        <!-- <div class="col my-auto "> <small>Talla : L</small></div> -->
                                        <div class="col my-auto "> <small>Cantidad: {{ detail.quantity }}</small></div>
                                        <div class="col my-auto ">
                                            <h6 class="mb-0">$ {{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(detail.price) }}</h6>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="media" v-if="detail.products_id == 41">
                                <p style="font-size: 13px;">
                                    <b>Nombre o empresa: </b>{{ detail.company }}<br>
                                    <b>Descripción de la muestra: </b>{{ detail.description }}<br>
                                    <b>Referencia del cliente: </b>{{ detail.reference }}<br>
                                    <b>Peso del producto: </b>{{ detail.weight }}<br>
                                    <b>Miligramos en producto: </b>{{ detail.ml }}<br>
                                    <b>Lote: </b>{{ detail.lote }}<br>
                                    <b>Datos que consideren necesario para el producto: </b>{{ detail.comments }}<br>
                                    <b>Nō de guía y Paquetería: </b>{{ detail.no_guide }}<br>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row mt-4">
                <div class="col">
                    <div class="row justify-content-between">
                        <div class="flex-sm-col text-right col">
                            <p class="mb-1"><b>Subtotal</b></p>
                        </div>
                        <div class="flex-sm-col col-auto">
                            <p class="mb-1">$ {{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(order.subtotal) }}</p>
                        </div>
                    </div>
                    <div class="row justify-content-between">
                        <div class="flex-sm-col text-right col">
                            <p class="mb-1"><b>Los gastos de envío</b></p>
                        </div>
                        <div class="flex-sm-col col-auto">
                            <p class="mb-1">$ {{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(order.shippingCost) }}</p>
                        </div>
                    </div>

                    <div class="row justify-content-between">
                        
                        <div class="flex-sm-col text-right col">
                            <p class="mb-1"><b>Descuento</b></p>
                        </div>
                        <div class="flex-sm-col col-auto">
                            <p class="mb-1">$ {{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(order.discount) }}</p>
                        </div>
                    </div>
                    
                    <div class="row justify-content-between">
                        <div class="flex-sm-col text-right col">
                            <p class="mb-1"><b>Total</b></p>
                        </div>
                        <div class="flex-sm-col col-auto">
                            <p class="mb-1">$ {{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(order.total) }}</p>
                        </div>
                    </div>
                    <div class="row justify-content-between" v-if="order.type_payment == 'Parcial'">
                        <div class="flex-sm-col text-right col">
                            <p class="mb-1"><b>Pago pacial a pagar ({{order.percent_type_payment}}%)</b></p>
                        </div>
                        <div class="flex-sm-col col-auto">
                            <p class="mb-1">$ {{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(order.total * (order.percent_type_payment / 100), 2) }}</p>
                        </div>
                    </div>

                </div>
            </div>

           
           

            <!-- <div class="row mt-4">
                <div class="col">
                    <div class="row justify-content-between">
                        <div class="col-auto">
                            <p class="mb-1 text-dark"><b>Detalles del pedido</b></p>
                        </div>
                        <div class="flex-sm-col text-right col">
                            <p class="mb-1"><b>Total</b></p>
                        </div>
                        <div class="flex-sm-col col-auto">
                            <p class="mb-1">$ {{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(order.subtotal) }}</p>
                        </div>
                    </div>

                    <div class="row justify-content-between">
                        <div class="flex-sm-col text-right col">
                            <p class="mb-1"><b>Los gastos de envío</b></p>
                        </div>
                        <div class="flex-sm-col col-auto">
                            <p class="mb-1">$ {{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(order.shippingCost) }}</p>
                        </div>
                    </div>
                </div>
            </div> -->

           
        </div>
        <div class="card-footer">
            <div class="jumbotron-fluid">
                <div class="row justify-content-between ">
                    <div class="col-auto my-auto ">
                        <h2 class="mb-0 font-weight-bold">TOTAL</h2>
                    </div>
                    <div class="col-auto my-auto ml-auto" v-if="order.type_payment == 'Parcial'">
                        <h1 class="display-3 ">$ {{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(order.total * (order.percent_type_payment / 100), 2) }}</h1>
                    </div>
                    <div class="col-auto my-auto ml-auto" v-else>
                        <h1 class="display-3 ">$ {{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(order.total) }}</h1>
                    </div>
                </div>
            </div>
        </div>
        <br>
        <div class="card-body" v-if="order.status == 'No Pagado' && order.paymentMethod != 'Mercadopago'">
                <div class="col">
                    <p>Por favor enviar su comprobante de pago a <b>pay@extractoseum.com</b><br>
                        <a class="btn btn-info btn-sm" target="_blank" href="https://wa.me/525519253043"><i class="fab fa-whatsapp"></i> Whatsapp</a>
                    </p>
                </div>
            </div>
      </div>
      <sweet-modal ref="modalLoading">
        <div class="fa-3x" ><i class="fas fa-spinner fa-pulse"></i></div><br/>
        <div>Cargando ...</div>
        
      </sweet-modal>
      <sweet-modal :icon="modal.icon" :blocking="modal.block" :hide-close-button="modal.block" ref="modal">
        <div class="fa-3x" v-if="modal.icon== ''"><i class="fas fa-spinner fa-pulse"></i></div><br/>
        {{modal.msg}}
        <div class="col-12 text-center" style="padding-top: 20px;" v-if="modal.icon == 'success'">
        <b-button class="btn btn-primary" slot="button" v-on:click.prevent="$refs.modal.close();">OK</b-button>
        </div>
        </sweet-modal>

  </div>
</template>

<script>
export default {
  data() {
    return {
        id: null,
        order: [],
        orderDetail: [],
        depositinfo:null,
        preferenceId:null,
        states:[],
        towns:[],
        modal:{
            msg:'',
            icon:'',
            block:false,
        },
    }
  },
  
  methods: {

    getContent: function(id){
        this.$refs.modalLoading.open();
      axios.get(tools.url('/api/user/order/'+id)).then(({data}) =>{
        this.order = data.order;
        this.orderDetail = data.orderDetail;
        this.$refs.modalLoading.close();
      }).catch((error)=>{
        this.$refs.modalLoading.close();
        console.log(error);
        this.$router.push("/");
      })
    },
    getDepositinfo(){
      axios.get(tools.url('/api/informaciondeposito')).then((response)=>{
        this.depositinfo = response.data;
      }).catch((error)=>{
         console.log(error);
      });
    },
    async loadMercadopago(){
      var self = this;
      this.$refs.modalLoading.open();
      try {
        // Hacemos la solicitud a tu backend para crear la preferencia
        const response = await axios.get('/api/mercadopago/create-preference-id/'+this.id,);

        // Obtener el ID de la preferencia desde la respuesta
        this.preferenceId = response.data.id;

        // Inicializamos el SDK de Mercado Pago
        const mp = new MercadoPago('APP_USR-84b970a1-4b88-460e-a4c0-214b6ff4a2a0', {
          locale: 'es-MX', // O el idioma que prefieras
        });
        
        
        mp.bricks().create("wallet", "brick-checkout", {
          initialization: {
              preferenceId: this.preferenceId,
          }
        }).then(() => {

          self.$refs.modalLoading.close();
   
        }).catch((error) => {
            self.$refs.modalLoading.close();
          alert('Error la cargar Mercado pago');
          
        });

      } catch (error) {
        self.$refs.modalLoading.close();
        alert('Error la cargar Mercado pago.');
        
      }
    },
    getStates(){
      axios.get(tools.url('/api/states')).then((response)=>{
        this.states = response.data;
      }).catch((error)=>{
         console.log(error);
      });
    },
    getTowns(){
      if(this.order.state_id){
        axios.get(tools.url('/api/towns/' + this.order.state_id)).then((response)=>{
          this.towns = response.data;
        }).catch((error)=>{
          console.log(error);
        });
      }
    },
    updateOrder(){
        this.$refs.modalLoading.open();
        axios.post(tools.url('/api/user/orderupdate/'+this.id),this.order).then(({data}) =>{
            this.$refs.modalLoading.close();
            this.modal.block = false;
            this.modal.icon = "success";
            this.modal.msg = 'Informacion actualizada correctamente';
            this.$refs.modal.open();
            
        }).catch((error)=>{
            this.$refs.modalLoading.close();

            this.modal.block = false;
            this.modal.icon = "error";
            this.modal.msg = 'Error al actualizar la informacion';
            this.$refs.modal.open();
           
        })
    }

  },

  mounted(){
    this.getStates();
    this.getDepositinfo();
    if(this.$route.params.id){
        this.id = this.$route.params.id;
        this.getContent(this.$route.params.id);
    }else{
        this.$router.push("/");
    }
  },

  watch: {
    '$route':function(){
      if(this.$route.params.id){
        this.id = this.$route.params.id;
        this.getContent(this.$route.params.id);
      }
    },
    'order.paymentMethod':function(){
        if(this.order.paymentMethod == 'Mercadopago'){
            if(this.order.status == 'No Pagado'){
                this.loadMercadopago();
            }
            
        }
        
    }
  }

}
</script>
